
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "addprotocol",
})

export default class addprotocol extends Vue {
	
  data() {
    return {
		dialogImageUrl: '',
        dialogVisible: false,
		isEdit:true
    }
  };
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form:any = {};
  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
	console.log('===');
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }

  private onSubmit() {
    console.log(this.form);
  }
  private addSubmit(){

    console.log(this.form);
	// 新增协议
	let paramter:any = {
		'agreements':this.form.protocolname,
		'appName':this.form.appname,
		'content':this.form.content,
		'type':this.form.protocolType
	};
	this.$http.post("agreements/create/", paramter).then((res: any) =>{
		
			this.$confirm('编辑成功');
			this.dialogVisible = false;
			window.location.reload();
	});
  }
  private userStateChange(item) {

    // 是否启用
    console.log(item);
  }
  private handleUpdate(index, row){
    // 编辑品牌
    console.log(row);
  }
  private handleDelete(index, row){
    // 删除品牌
    console.log(row);
  }
  private handleRemove(file, fileList) {
    console.log(file, fileList);
  }
  private handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
}
